import { registerSystem } from "yage/components/ComponentRegistry";
import { System } from "yage/components/System";
import { PlayerTypeSchema, EnemyTypeSchema } from "yage/components/entity/Types";
import { Component, Schema, defaultValue, type } from "yage/decorators/type";
import { GameModel } from "yage/game/GameModel";
import { ChildSchema } from "yage/schemas/entity/Child";
import { getPlayerCharacter } from "../../utils/playerCharacter";

@Component("ShareOnKill")
export class ShareOnKillSchema extends Schema {
  @type(["number"])
  @defaultValue([])
  entities: number[];

  @type("number")
  @defaultValue(-1)
  owner: number;

  @type("number")
  @defaultValue(-1)
  killedEntity: number;

  @type("number")
  @defaultValue(-1)
  killSource: number;
}

class ShareOnKillSystem implements System {
  schema = ShareOnKillSchema;
  type = "ShareOnKill";
  dependencies = ["Child"];

  init(entity: number, gameModel: GameModel) {
    if (
      !gameModel.hasComponent(entity, PlayerTypeSchema) &&
      !gameModel.hasComponent(entity, EnemyTypeSchema) &&
      gameModel.hasComponent(entity, ChildSchema)
    ) {
      let parent = gameModel.getTypedUnsafe(entity, ChildSchema).parent!;
      if (gameModel.hasComponent(parent, "PlayerInput")) {
        parent = getPlayerCharacter(parent, gameModel);
      }
      gameModel.addIfMissing(parent, ShareOnKillSchema);
      const parentData = gameModel.getTypedUnsafe(parent, ShareOnKillSchema);
      parentData.entities.push(entity);
    }
  }
}

registerSystem(ShareOnKillSystem);
